import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1> Route Not Found</h1>
        </div>
    );
};

export default NoMatch;